import * as THREE from 'three';
import { renderer } from '../scene/context.js';
import { requestRender } from '../state/bus.js';

const texCache = new Map();
export function getTexture(src, onReady){
  let e = texCache.get(src);
  if(e){
    if(onReady){ e.loaded ? onReady(e) : e.waiters.push(onReady); }
    return e;
  }
  e = {tex:null, aspect:1, loaded:false, error:false, waiters:onReady?[onReady]:[]};
  texCache.set(src, e);
  const t = new THREE.TextureLoader().load(src,
    img=>{
      e.aspect = (img.image.width / img.image.height) || 1;
      e.loaded = true;
      const w = e.waiters; e.waiters = [];
      w.forEach(fn=>fn(e));
      requestRender();
    },
    undefined,
    ()=>{ e.loaded = true; e.error = true; e.waiters = []; }
  );
  t.colorSpace = THREE.SRGBColorSpace;
  t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  e.tex = t;
  return e;
}

/* Apply an object's image map to its material, if it has one. Alpha comes from
   the image's own channel via alphaTest, so cut-out PNGs read as their shape. */
export function applyMap(o, m){
  if(!o.map || !o.map.src) return;
  const e = getTexture(o.map.src);
  m.map = e.tex;
  if(o.map.alpha !== false){
    m.transparent = true;
    m.alphaTest = o.map.cutoff==null ? .5 : o.map.cutoff;
  }
  m.needsUpdate = true;
}
